var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNailcare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Make-Up-Nail-Polisher--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Make Up Nail Polisher Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.37 9.22a25 25 0 0 1 2.71 -0.15 22.16 22.16 0 0 1 2.55 0.15 0.49 0.49 0 0 0 0.4 -0.14 0.5 0.5 0 0 0 0.16 -0.4l-0.62 -7.31A1.5 1.5 0 0 0 13.08 0h-2.16a1.5 1.5 0 0 0 -1.49 1.37l-0.62 7.32a0.51 0.51 0 0 0 0.16 0.4 0.48 0.48 0 0 0 0.4 0.13Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 12c-1 -1.38 -4.22 -1.87 -6.91 -1.88H12c-2.74 0 -6 0.49 -7 1.88a2.61 2.61 0 0 0 -0.47 2l2.13 8a2.52 2.52 0 0 0 2.45 2h5.76a2.51 2.51 0 0 0 2.44 -1.95l2.15 -8A2.62 2.62 0 0 0 19 12Zm-4.67 7.31a0.85 0.85 0 0 1 -0.84 0.74h-3a0.86 0.86 0 0 1 -0.84 -0.74L9.06 15a0.85 0.85 0 0 1 0.85 -1h4.18a0.85 0.85 0 0 1 0.85 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNailcare);
export default ForwardRef;